import { render, staticRenderFns } from "./competency.vue?vue&type=template&id=4e3e4782&scoped=true&"
import script from "./competency.ts?vue&type=script&lang=ts&"
export * from "./competency.ts?vue&type=script&lang=ts&"
import style0 from "./competency.scss?vue&type=style&index=0&id=4e3e4782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e4782",
  null
  
)

export default component.exports